import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=6444f8db&"
import script from "./ProfileHeader.vue?vue&type=script&lang=js&"
export * from "./ProfileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6444f8db')) {
      api.createRecord('6444f8db', component.options)
    } else {
      api.reload('6444f8db', component.options)
    }
    module.hot.accept("./ProfileHeader.vue?vue&type=template&id=6444f8db&", function () {
      api.rerender('6444f8db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/profile/ProfileHeader.vue"
export default component.exports